import axiosInstance from "./api";

/**
 * Full search across planners, performers, crew and blogs.
 *
 * @param {string} q          - Raw search query (e.g. "raj wedding mumbai")
 * @param {string} location   - Explicit location filter (from dropdown/input)
 * @param {object} pages      - Per-section page numbers
 * @param {number} pages.plannerPage
 * @param {number} pages.performerPage
 * @param {number} pages.crewPage
 * @param {number} pages.blogPage
 *
 * @returns {Promise<{
 *   planners:   { results, totalPages, currentPage, totalResults, isFallback },
 *   performers: { results, totalPages, currentPage, totalResults, isFallback },
 *   crew:       { results, totalPages, currentPage, totalResults, isFallback },
 *   blogs:      { results, totalPages, currentPage, totalResults, isFallback },
 * }>}
 */
export const searchAll = async (q, location = "", pages = {}) => {
  const {
    plannerPage = 1,
    performerPage = 1,
    crewPage = 1,
    blogPage = 1,
  } = pages;

  const params = new URLSearchParams({
    q,
    ...(location && { location }),
    plannerPage,
    performerPage,
    crewPage,
    blogPage,
  });

  const { data } = await axiosInstance.get(`/search/all?${params}`);
  return data;
};

/**
 * Lightweight suggestions for the search dropdown.
 * Returns instantly from queryParser (categories) + a small DB hit (people).
 *
 * @param {string} q - Partial query as user types
 *
 * @returns {Promise<{
 *   categories: string[],
 *   people: Array<{
 *     _id: string,
 *     companyName: string,
 *     profilePicture: { url: string },
 *     categories: string[],
 *     userInfo: { _id: string, purpose: string }
 *   }>
 * }>}
 */
export const getSuggestions = async (q) => {
  const { data } = await axiosInstance.get(
    `/search/suggestions?q=${encodeURIComponent(q)}`,
  );
  return data;
};
